var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('span',{staticClass:"lamp",class:_vm.value ? 'green' : 'orange'},[_vm._v(_vm._s(_vm.value ? '확인' : '미확인'))])])}
var staticRenderFns = []

export { render, staticRenderFns }